import type { FaireProductEntity } from "../../entity_types/product";

export const p_esxma26qmk: FaireProductEntity = {
  token: "p_esxma26qmk",
  type: "product",
  name: "Discovery Travel Set-  100% Natural Fragrance Oil Rollerball",
  brandToken: "b_ce86yex9ah",
  brandName: "Biology Functional Fragrances",
  imageUrl:
    "https://cdn.faire.com/fastly/872f10eecbf887e99b85cf62281a5d94ef6655a9670b8acee5edb1fb69803aa1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/533f9c021d9ee1dadc7964d4c63669ee0da780c1a614be1fb8d8b6d3ed230d8e.jpeg",
    "https://cdn.faire.com/fastly/1e8afe5f3929f779038b2b5c279cb8ec62f0409ae290789e7abb699978b4962c.jpeg",
    "https://cdn.faire.com/fastly/6fd91398df946e56850c2fb08f997d52331d0a4beae3d4a33b51fbdd241ebe3b.jpeg",
    "https://cdn.faire.com/fastly/86584e3fa8fc2c1ab9945d520e1d7f9571fbc32794fa88ce8b8bdcc9c52bb5bb.jpeg",
  ],
  priceDollars: 20,
  description:
    "A full-spectrum introduction to Biology. Each scent is designed around a different state so you can shift how you feel, not just how you smell.\n\nWear them individually or layer to create something your own. Perfect for discovery, gifting, or on-the-go refresh - keep one in your bag, one at home, one for wherever the day takes you. What you'll experience:\n\nUplift → JOY\nEnergy → STELLAR\nAllure → MYSTERY\nWarmth → DEEP\nClarity → BALANCE\nCalm → OTHERWORLDLY\n\nYour 30% Off Code will be sent after purchase.\n\n6 x 2ml sample vials\n100% natural • alcohol-free • paraben-free • phthalate-free\nMade in the USA\n\nAromatherapy meets fine fragrance. Made for pockets, purses, and wherever the day takes you.\n\nNote: All sample kits are final sale. No returns accepted.",
  tags: [],
  msrpDollars: 40,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:16.805Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
